var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhoneLoom = function SvgPhoneLoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "#1874FD",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.626 28.528a1.804 1.804 0 0 0 1.29-.533l2.447-2.446a.903.903 0 0 0 0-1.273l-3.61-3.611a.903.903 0 0 0-1.274 0L21.035 22.1a6.815 6.815 0 0 1-2.709-1.435 6.879 6.879 0 0 1-1.435-2.709l1.435-1.444a.903.903 0 0 0 0-1.273l-3.61-3.611a.903.903 0 0 0-1.274 0l-2.437 2.455a1.808 1.808 0 0 0-.533 1.291 13.795 13.795 0 0 0 3.882 9.272 13.795 13.795 0 0 0 9.272 3.882ZM14.083 13.55l2.339 2.338-1.165 1.165a.903.903 0 0 0-.27.821 9.135 9.135 0 0 0 2.075 4.063 9.1 9.1 0 0 0 4.063 2.076.902.902 0 0 0 .822-.244l1.164-1.192 2.338 2.339-1.805 1.805a11.989 11.989 0 0 1-8.008-3.35 11.988 11.988 0 0 1-3.358-8.016l1.805-1.805Zm12.64 5.046h1.805a7.954 7.954 0 0 0-8.125-8.125v1.806a6.11 6.11 0 0 1 6.32 6.32Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.403 15.889c1.896 0 2.708.812 2.708 2.708h1.806c0-2.907-1.607-4.514-4.514-4.514v1.806Z",
    fill: "#fff"
  })));
};

export default SvgPhoneLoom;